var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdminIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.14351 13.7502V6.19308M10.0007 13.7978V10.0026M12.8578 13.8121V8.09784M5.23875 3.33594H14.7626C15.2677 3.33594 15.7522 3.53662 16.1094 3.89383C16.4666 4.25104 16.6673 4.73552 16.6673 5.2407V14.7645C16.6673 15.2697 16.4666 15.7542 16.1094 16.1114C15.7522 16.4686 15.2677 16.6693 14.7626 16.6693H5.23875C4.73357 16.6693 4.24909 16.4686 3.89188 16.1114C3.53466 15.7542 3.33398 15.2697 3.33398 14.7645V5.2407C3.33398 4.73552 3.53466 4.25104 3.89188 3.89383C4.24909 3.53662 4.73357 3.33594 5.23875 3.33594Z",
    stroke: "#243142",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminIcon);
export default __webpack_public_path__ + "static/media/adminIcon.25e1062a15faaefd35134f0d076ec022.svg";
export { ForwardRef as ReactComponent };